import React, { useRef, useState } from 'react';
import ReactAudioPlayer from 'react-audio-player';
import { Button } from 'reactstrap/lib';

type Props = {
  audioUrl: string;
};

export default function AudioButton({ audioUrl }: Props) {
  const refAudio = useRef<HTMLAudioElement>(null);
  const [isPlaying, setIsPlaying] = useState(false);

  const playAudio = React.useCallback(() => {
    refAudio?.current?.play();
    setIsPlaying(true);
  }, []);

  if (!audioUrl) return null;

  return (
    <div className='mb-4'>
      {isPlaying ? (
        <ReactAudioPlayer ref={refAudio} id='myAudio' style={{ height: 43 }} src={audioUrl} autoPlay controls />
      ) : (
        <Button
          color='warning'
          onClick={() => {
            playAudio();
          }}
        >
          <i className='fas fa-play' />
          &nbsp;&nbsp;Click to listen
        </Button>
      )}
    </div>
  );
}
